let selectedRegion = null;

function setupMapInteraction() {
  const mapRegions = document.querySelectorAll("#map .land");
  const selectEstado = document.getElementById("estado");
  if (!selectEstado) return;

  mapRegions.forEach((region) => {
    region.addEventListener("click", function () {
      const stateCode = this.id.split("-")[1];
      if (!stateCode) return;

      if (selectedRegion) {
        selectedRegion.classList.remove("selected");
      }
      this.classList.add("selected");
      selectedRegion = this;

      selectEstado.value = stateCode;
      const event = new Event("change");
      selectEstado.dispatchEvent(event);

      document.getElementById("cidade").value = "";
      document.getElementById("cidade").focus();
    });

    region.addEventListener("mouseover", function () {
      if (this !== selectedRegion) {
        this.classList.add("hover-color");
      }
    });

    region.addEventListener("mouseout", function () {
      this.classList.remove("hover-color");
    });
  });

  selectEstado.addEventListener("change", function () {
    const selectedCode = this.value;

    if (selectedRegion) {
      selectedRegion.classList.remove("selected");
    }

    if (selectedCode) {
      const targetId = "BR-" + selectedCode;
      const targetRegion = document.getElementById(targetId);
      if (targetRegion) {
        targetRegion.classList.add("selected");
        selectedRegion = targetRegion;
      } else {
        selectedRegion = null;
      }
    } else {
      selectedRegion = null;
    }

    document.getElementById("cidade").value = "";
    filtrarFornecedores();
  });
}

async function carregarEstadosECidades() {
  const estadoSelect = document.getElementById("estado");
  const cidadeSelect = document.getElementById("cidade");
  if (!estadoSelect || !cidadeSelect) return;

  const estados = await fetch(
    "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
  )
    .then((res) => res.json())
    .catch(() => []);

  estados.sort((a, b) => a.nome.localeCompare(b.nome));

  estadoSelect.innerHTML = '<option value="">Selecione um estado</option>';
  estados.forEach((estado) => {
    const opt = document.createElement("option");
    opt.value = estado.sigla;
    opt.textContent = estado.nome;
    estadoSelect.appendChild(opt);
  });

  estadoSelect.addEventListener("change", async () => {
    const sigla = estadoSelect.value;
    cidadeSelect.innerHTML = '<option value="">Carregando cidades...</option>';

    if (!sigla) {
      cidadeSelect.innerHTML =
        '<option value="">Selecione um estado primeiro</option>';
      filtrarFornecedores();
      return;
    }

    const cidades = await fetch(
      `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${sigla}/municipios`
    )
      .then((res) => res.json())
      .catch(() => []);

    cidadeSelect.innerHTML = '<option value="">Selecione a cidade</option>';
    cidades.forEach((cidade) => {
      const opt = document.createElement("option");
      opt.value = cidade.nome;
      opt.textContent = cidade.nome;
      cidadeSelect.appendChild(opt);
    });
  });

  cidadeSelect.addEventListener("change", () => {
    filtrarFornecedores();
  });
}

function filtrarFornecedores() {
  const estadoSelecionado = document.getElementById("estado").value;
  const cidadeSelecionada = document.getElementById("cidade").value;
  const resultadosDiv = document.querySelector(".distribuidores-resultados");
  if (!estadoSelecionado) {
    ocultarTodosCards();
    return;
  }

  let encontrouFornecedor = false;

  if (window.fornecedoresData && window.fornecedoresData.length > 0) {
    window.fornecedoresData.forEach((fornecedor, index) => {
      const card = resultadosDiv.children[index];
      if (!card || !card.classList.contains("distribuidor-card")) {
        return;
      }
      const estadoFornecedor = normalizarTexto(fornecedor.estado);
      const cidadeFornecedor = normalizarTexto(fornecedor.cidade);
      const estadoBusca = normalizarTexto(estadoSelecionado);
      const cidadeBusca = normalizarTexto(cidadeSelecionada);
      const estadoMatch = estadoFornecedor === estadoBusca;
      const cidadeMatch = cidadeFornecedor === cidadeBusca;
      if (estadoMatch && (!cidadeSelecionada || cidadeMatch)) {
        card.style.display = "block";
        encontrouFornecedor = true;
      } else {
        card.style.display = "none";
      }
    });
  }

  let mensagemNaoEncontrado = document.getElementById(
    "mensagem-nao-encontrado"
  );

  if (!encontrouFornecedor) {
    if (!mensagemNaoEncontrado) {
      mensagemNaoEncontrado = document.createElement("p");
      mensagemNaoEncontrado.id = "mensagem-nao-encontrado";
      mensagemNaoEncontrado.className = "mensagem-sem-fornecedores";
      mensagemNaoEncontrado.textContent =
        "Nenhum fornecedor encontrado para esta localidade.";
      resultadosDiv.appendChild(mensagemNaoEncontrado);
    }
    mensagemNaoEncontrado.style.display = "block";
  } else {
    if (mensagemNaoEncontrado) {
      mensagemNaoEncontrado.style.display = "none";
    }
  }
}
function ocultarTodosCards() {
  const cards = document.querySelectorAll(".distribuidor-card");
  cards.forEach((card) => (card.style.display = "none"));

  const mensagem = document.getElementById("mensagem-nao-encontrado");
  if (mensagem) {
    mensagem.style.display = "none";
  }
}

function normalizarTexto(texto) {
  if (!texto) return "";
  return texto
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
}

document.addEventListener("DOMContentLoaded", () => {
  carregarEstadosECidades();

  ocultarTodosCards();
});

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".form-tab");
  const forms = document.querySelectorAll(".form-content");
  const description = document.querySelector(".form-description");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      if (tab.dataset.link) {
        window.location.href = tab.dataset.link;
        return;
      }

      tabs.forEach((t) => t.classList.remove("active"));
      forms.forEach((f) => {
        f.classList.remove("active");
        f.style.display = "none";
      });

      tab.classList.add("active");
      const target = document.getElementById("form-" + tab.dataset.form);
      target.classList.add("active");
      target.style.display = "block";

      if (tab.dataset.form === "revendedor") {
        description.style.display = "none";
      } else {
        description.style.display = "block";
      }
    });
  });

  forms.forEach((f, i) => {
    f.style.display = i === 0 ? "block" : "none";
  });

  setupMapInteraction();
});

document.addEventListener("DOMContentLoaded", function () {
  const botoesMapa = document.querySelectorAll(".btn-mapa");

  botoesMapa.forEach((botao) => {
    botao.addEventListener("click", function () {
      let url = this.getAttribute("data-mapa-url");
      abrirMapa(url);
    });
  });
});

function abrirMapa(url) {
  const modal = document.getElementById("mapa-modal");
  const iframe = document.getElementById("mapa-iframe");

  let urlLimpa = url.trim();

  if (urlLimpa.includes("<iframe")) {
    const srcMatch = urlLimpa.match(/src="([^"]+)"/i);
    if (srcMatch && srcMatch[1]) {
      urlLimpa = srcMatch[1];
    }
  }

  iframe.src = urlLimpa;
  modal.classList.add("active");
}

function fecharMapa() {
  const modal = document.getElementById("mapa-modal");
  const iframe = document.getElementById("mapa-iframe");
  modal.classList.remove("active");
  iframe.src = "";
}

document.addEventListener("DOMContentLoaded", () => {
  const formRevendedor = document.getElementById("form_revendedor");
  const submitButton = formRevendedor?.querySelector(".button--primary-form");

  if (!formRevendedor || !submitButton) return;

  formRevendedor.addEventListener("submit", function (e) {
    submitButton.disabled = true;
    submitButton.textContent = "Enviando...";

    setTimeout(() => {
      submitButton.textContent = "Enviado!";
      submitButton.classList.add("success");
      setTimeout(() => {
        submitButton.classList.remove("success");
        submitButton.disabled = false;
        submitButton.textContent = "Enviar";
      }, 4000);
    }, 800);
  });
});

function abrirModal() {
  document.getElementById("form-success-modal").style.display = "flex";
}

function fecharModal() {
  document.getElementById("form-success-modal").style.display = "none";
}
